import React from 'react';

import { NodeProps } from './shared';

interface SubheadingNodeProps extends NodeProps {
  type: 'h4' | 'h5' | 'h6';
}

const getSubheadingClasses = (type: 'h4' | 'h5' | 'h6'): string => {
  const baseClasses = 'font-medium mt-6 mb-3 tablet:mt-8 tablet:mb-4';

  const typeClasses = {
    h4: 'text-lg leading-[1.125rem] tablet:text-[1.375rem] tablet:leading-[1.5rem]',
    h5: 'text-[1.0625rem] leading-[0.875rem] tablet:text-lg tablet:leading-[1.125rem]',
    h6: 'text-base leading-[0.875rem] tablet:text-lg tablet:leading-[1.125rem]'
  };

  return `${baseClasses} ${typeClasses[type]}`;
};

export function SubheadingNode({ children, type }: SubheadingNodeProps) {
  const SubheadingTag = type;

  return (
    <SubheadingTag className={getSubheadingClasses(type)}>
      {children}
    </SubheadingTag>
  );
}
